module.exports = __webpack_public_path__ + "img/marker_no_shadow.be11063b.svg";